import React, { useEffect } from "react";
import { Severity } from "@eveworld/types";
import { useNotification, useSmartObject } from "@eveworld/contexts";

import { ErrorNotice, ErrorNoticeTypes } from "@eveworld/ui-components";

import { JSX } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import SidebarOfficer from "./SidebarOfficer";
import InitVars from "../../src/InitVars";
import OfficerPlayerList from "./officer/OfficerPlayerList";

// React.memo
const Officer = React.memo(
  () //   {
  : JSX.Element => {
    const { smartCharacter, loading } = useSmartObject();
    const { notify, handleClose } = useNotification();

    const sidebar = React.useMemo(() => <SidebarOfficer />, []);

    //const { worldContract } = useWorldContract();

    useEffect(() => {
      if (loading) {
        notify({ type: Severity.Info, message: "Loading..." });
      } else {
        handleClose();
      }
    }, [loading]);

    if ((!loading && !smartCharacter) || !smartCharacter?.isSmartCharacter) {
      return (
        <ErrorNotice
          type={ErrorNoticeTypes.MESSAGE}
          errorMessage="Unknown Character"
        />
      );
    }

    if (
      (smartCharacter.corpId == "98000002" || smartCharacter.corpId == "") &&
      (smartCharacter.name == "Tapticc" ||
        smartCharacter.name == "Scetrov" ||
        smartCharacter.name == "migsyourboy" ||
        smartCharacter.name == "Michael JD" ||
        smartCharacter.name == "CleoMouri" ||
        smartCharacter.name == "Haiyooo" ||
        smartCharacter.name == "Shei Hullud" ||
        smartCharacter.name == "Mesic" ||
        smartCharacter.name == "Mystichal" ||
        smartCharacter.name == "J D" ||
        smartCharacter.name == "Ordom" ||
        smartCharacter.name == "Zlake")
    ) {
      //Reapers corp id
      return (
        <>
          <div className="container">
            {/* <SideBar /> */}
            {sidebar}
            <Box
              sx={{
                height: "94vh",
                paddingLeft: 1,
              }}
            >
              <div className="grid">
                {InitVars.sidebarOption == "" && (
                  <p>Welcome {smartCharacter.name} to the Officer page</p>
                )}
                {InitVars.sidebarOption == "OfficerPlayerList" && (
                  <OfficerPlayerList
                    smartCharacterAddress={smartCharacter.address}
                  ></OfficerPlayerList>
                )}
              </div>
            </Box>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="container">
            <Box
              sx={{
                height: "94vh",
                paddingLeft: 1,
              }}
            >
              <div className="grid">
                <p>
                  Welcome {smartCharacter.name}, you are not a member of Reapers
                  Officers sorry
                </p>
              </div>
            </Box>
          </div>
        </>
      );
    }
  }
);

export default React.memo(Officer);
